import { atom } from 'jotai'
import Big from 'big.js'
import { AnyToken } from 'src/common/types/models/Tokens'
import { DotcEnums } from 'src/common/contracts/enums/dotc'
import { OfferOptions } from 'src/common/contracts/hooks/dotc/useMakeOffer/types'
import dayjs from 'dayjs'
import {
  findBestOffers,
  OfferWithTake,
} from 'src/common/utils/offers/findBestOffers'
import { Offer } from 'src/common/types/models/Offer'
import cloneDeep from 'lodash/cloneDeep'
import { OfferType } from 'src/common/apollo/types/swarmx/graphql'
import { ZERO } from 'src/common/utils/big-utils'

export const showOffersToTakeAtom = atom(false)

export const sellTokenAtom = atom<AnyToken>()
export const sellTokenAmountAtom = atom<Big>(ZERO)

export const buyTokenAtom = atom<AnyToken>()
export const buyTokenAmountAtom = atom<Big>(ZERO)

export const pricePerUnitAtom = atom<Big>(ZERO)

export const successfulTxHashAtom = atom<string>()
export const successfulCreatedOfferIdAtom = atom<string | null>(null)

export const offersAtom = atom<Offer[]>([])
export const offersWithAmountOutAtom = atom(get =>
  cloneDeep(get(offersAtom)).map(offer => ({
    ...offer,
    availableAmountOut:
      offer.offerType === OfferType.PartialOffer
        ? offer.availableAmount.mul(offer.amountOut!.div(offer.amountIn))
        : offer.amountOut!,
  }))
)
export const bestOffersModeAtom = atom<number>(0)
export const bestOffersAtom = atom<OfferWithTake[]>(get =>
  findBestOffers(
    cloneDeep(get(offersWithAmountOutAtom)),
    get(bestOffersModeAtom) === 0
      ? get(sellTokenAmountAtom)
      : get(buyTokenAmountAtom),
    get(bestOffersModeAtom)
  )
)
export const skipOfferToTakeIdsAtom = atom<string[]>([])
export const offersToTakeAtom = atom<OfferWithTake[]>([])
export const priceSwappedAtom = atom<boolean>(false)

interface LimitOrderOptionsState extends OfferOptions {
  takingOfferType: DotcEnums.TakingOfferType
  dynamic: boolean
  percentage: number | null
  percentageType: DotcEnums.PercentageType | null
  authorizationAddresses: string[]
  otherAuthorizationAddress: string | null
}
export const limitOrderOptionsAtom = atom<LimitOrderOptionsState>({
  takingOfferType: DotcEnums.TakingOfferType.PartialOffer,
  specialAddresses: [],
  authorizationAddresses: ['0xb161fb38ccCe7E70a010a60736cf579AB6cA130d'],
  otherAuthorizationAddress: null,
  expiryTimestamp: dayjs().add(2, 'year').unix(),
  timelockPeriod: 0,
  terms: '',
  commsLink: '',
  dynamic: false,
  percentage: 0,
  percentageType: null,
})

export const verifyModalAtom = atom<boolean>(false)
export const kycModalAtom = atom<boolean>(false)
